const config: Config = {
  apiBaseUrl: process.env.REACT_APP_API_DOMAIN || '/api',
  authUrl: process.env.REACT_APP_API_DOMAIN + '/auth/login',
  defaultPageSize: 15,
  migration: process.env.REACT_APP_MIGRATION || '',
  version: process.env.REACT_APP_VERSION || '',
}

export default config
